export default function Photo() {
  return (
    <>
      <p align="left">
        <a class="1" href="/">
          main
        </a>
        {' > '}
        <a class="1" href="/art">
          art
        </a>
        {' > '}
        <a class="1" href="/photos">
          photography
        </a>
      </p>
      <table width="100%" border="0" cellspacing="0" cellpadding="0">
        <tr align="center">
          <td>
            <a href="/photos/concept">
              <img
                id="png"
                src="/assets/i/icons.png"
                width="120"
                height="120"
              />
              <br />
              Concept
            </a>
          </td>
          <td>
            <a href="/photos/macro">
              <img
                id="png"
                src="/assets/i/icons.png"
                width="120"
                height="120"
              />
              <br />
              Macro
            </a>
          </td>
        </tr>
        <tr align="center">
          <td>
            <a href="/photos/people">
              <img
                id="png"
                src="/assets/i/icons.png"
                width="120"
                height="120"
              />
              <br />
              People
            </a>
          </td>
          <td>
            <a href="/photos/scene">
              <img
                id="png"
                src="/assets/i/icons.png"
                width="120"
                height="120"
              />
              <br />
              Scene
            </a>
          </td>
        </tr>
        <tr align="center">
          <td colspan="2">
            <a href="/photos/sky">
              <img
                id="png"
                src="/assets/i/icons.png"
                width="120"
                height="120"
              />
              <br />
              Sky
            </a>
          </td>
        </tr>
      </table>
      <p align="left">&nbsp;</p>
    </>
  );
}
